import React from 'react';
import Image from '@wix/thunderbolt-elements/src/components/Image/viewer/Image';
import styles from './style/FastGalleryImageRenderer.module.scss';
import classNames from 'clsx';
import type { ImageRendererProps, Point } from '@wix/fast-gallery-library';

const DEFAULT_GALLERY_FOCAL_POINT = {
  x: 0.5,
  y: 0.5,
};

const galleryItemFocalPointToWowImageFocalPoint = (
  focalPoint: Point = DEFAULT_GALLERY_FOCAL_POINT,
) => {
  return {
    x: focalPoint?.x * 100,
    y: focalPoint?.y * 100,
  };
};
const getUrl = (itemData: ImageRendererProps['data']) => {
  if (itemData.uri) {
    return itemData.uri;
  }
  return Array.isArray(itemData.mediaUrl)
    ? itemData.mediaUrl[0].url
    : itemData.mediaUrl;
};
export const FastGalleryImageRenderer = (props: ImageRendererProps) => {
  const { selectors, data } = props;
  const { metaData } = data;
  const { focalPoint } = metaData;
  return (
    <div
      className={classNames(styles.imageContainer)}
      style={
        {
          // wow-image uses this trick with aspect-ratio to handle responsive auto height in studio
          '--aspect-ratio': metaData.width / metaData.height,
        } as React.CSSProperties
      }
    >
      <div
        className={classNames(styles.imageWrapper, 'image-renderer-wrapper')}
      >
        <Image
          className={classNames(selectors?.image, styles.image)}
          uri={getUrl(data)}
          width={metaData.width}
          height={metaData.height}
          displayMode="fill"
          alt={metaData.alt}
          name={metaData.title}
          focalPoint={galleryItemFocalPointToWowImageFocalPoint(focalPoint)}
          encoding="AVIF"
        />
      </div>
    </div>
  );
};
